import { hasFeatureEditPermission } from '@/commons/utils';

export default function createPermissionMixin(featureKey) {
  return {
    computed: {
      hasEditPermission() {
        return hasFeatureEditPermission(this.$store, featureKey);
      }
    },
    watch: {
      hasEditPermission(newVal) {
        this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !newVal });
      }
    },
    mounted() {
      // Emit initial state
      this.$nextTick(() => {
        this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.hasEditPermission });
      });
    }
  };
}
